<div class="table" role="table" [attr.aria-label]="title">
    <div class="header" [ngClass]="mealPeriodClass" role="row">
        <div class="name" role="columnheader">{{title}}</div>
        <ng-container *ngIf="!singleYear; else meals">
            <div class="container" *ngFor="let year of years">
                <ng-container *ngTemplateOutlet="meals; context: {$implicit: mealPeriods}"></ng-container>
                <span role="columnheader">{{year}}</span>
            </div>
        </ng-container>
        <ng-template #meals>
            <div class="container">
                <span class="meal-period" *ngFor="let mealPeriod of mealPeriods" role="columnheader">
                    {{mealPeriod}}
                </span>
            </div>
        </ng-template>
    </div>
    <finder-dining-plan *ngFor="let plan of plans"
        [plan]="plan"
        [mealPeriods]="mealPeriods"
        [mealPeriodClass]="mealPeriodClass"
        [notAccepted]="notAccepted">
    </finder-dining-plan>
    <hr>
</div>
